<template>
  <!-- 横柱状图 -->
  <div :ref="refId" :datas="datas" style="width: 100%; height: 100%"></div>
</template>

// refId 图表id // datas 图表数据源 // transverseData y轴的数值或名称 // colorList 颜色值 //
gridHeight 图表的高度 // gridY 图表距离顶部的距离 // seriesColor 柱状颜色是否渐变 // axisLineShow
是否显示纵轴轴线 // isShowTextColor 是否导出时候横轴纵轴显示黑色字 // isExportTextColor
是否给导出页面时候横轴纵轴显示设置字体25

<script>
export default {
  props: [
    "refId",
    "datas",
    "transverseData",
    "colorList",
    "innerText",
    "gridHeight",
    "gridY",
    "seriesColor",
    "axisLineShow",
    "isShowTextColor",
    "isExportTextColor",
  ],
  data() {
    return {
      pieEcharts: "",
      pieOption: {},
    };
  },
  watch: {
    datas: {
      handler(newValue, oldValue) {
        this.setPieOption(
          this.refId,
          newValue,
          this.transverseData,
          this.colorList,
          this.innerText,
          this.gridHeight,
          this.gridY,
          this.seriesColor,
          this.axisLineShow,
          this.isShowTextColor,
          this.isExportTextColor
        );
      },
      deep: true,
    },
  },
  beforeDestroy() {
    if (this.pieEcharts) {
      this.pieEcharts.clear();
    }
  },
  mounted() {
    if (this.datas && this.datas.length > 0) {
      this.setPieOption(
        this.refId,
        this.datas,
        this.transverseData,
        this.colorList,
        this.innerText,
        this.gridHeight,
        this.gridY,
        this.seriesColor,
        this.axisLineShow,
        this.isShowTextColor,
        this.isExportTextColor
      );
    }
  },
  methods: {
    setPieOption(
      refId,
      datas,
      transverseData,
      colorList,
      innerText,
      gridHeight,
      gridY,
      seriesColor,
      axisLineShow,
      isShowTextColor,
      isExportTextColor
    ) {
      const arrlist = [];
      const yAxisData = [];
      const seriesData = [];
      for (let i = 0; i < datas.length; i++) {
        arrlist.push({
          name: transverseData[i],
          value: datas[i],
        });
      }
      arrlist.sort((a, b) => a.value - b.value);

      const cacheList = JSON.parse(JSON.stringify(arrlist)); // tooltip显示完整的纵坐标名字

      for (let i = 0; i < arrlist.length; i++) {
        if (arrlist[i].name.length > 11) {
          arrlist[i].name = `${arrlist[i].name.substring(0, 11)}...`;
        }
        yAxisData.push(arrlist[i].name);
        seriesData.push(arrlist[i].value);
      }
      if (colorList.length <= 0) {
        colorList = ["#fff"];
      }

      if (!innerText) {
        innerText = "";
      } else {
        innerText = innerText;
      }

      this.pieEcharts = this.$echarts.init(this.$refs[refId]);
      this.pieOption = {
        tooltip: {
          trigger: "axis",
          confine: true, // 浮窗限制在图表内
          backgroundColor: "rgba(64, 80, 118, 0.8)", // 通过设置rgba调节背景颜色与透明度
          borderColor: "rgba(64, 80, 118, 0.8)",
          color: "#fff",
          textStyle: {
            color: "#fff",
          },
          axisPointer: {
            type: "shadow",
            label: {
              backgroundColor: "#6a7985",
            },
          },
          formatter: (parmes) =>
            `${cacheList[parmes[0].dataIndex].name}<br/>${parmes[0].marker}   ${parmes[0].value}`,
        },
        legend: {},
        grid: {
          left: "3%",
          // right: '5%',
          // bottom: '10%',
          containLabel: true,
          x: "12%", // x 偏移量
          y: gridY || "12%", // y 偏移量
          width:
            isShowTextColor && !isExportTextColor
              ? "86%"
              : isShowTextColor && isExportTextColor
              ? "86%"
              : "95%", // 宽度
          height: gridHeight || "82%", // 高度
        },
        xAxis: {
          // name: `${innerText}`,
          type: "value", // 将xAxis的type设置为value, 将yAxis的type设置为category即可实现横向显示
          axisLine: { show: true }, // 轴线
          axisTick: {
            show: false,
            lineStyle: {
              type: "dotted",
            },
          }, // 刻度
          splitLine: {
            show: true,
            lineStyle: {
              // type: "dashed",  //虚线
              color: "rgba(255,255,255,0.3)",
            },
          }, // 分隔线
          axisLabel: {
            // x轴坐标轴样式
            textStyle: {
              color: isShowTextColor ? "#1d244e" : "#bcc2cf",
              fontSize:
                isShowTextColor && !isExportTextColor
                  ? 14
                  : isShowTextColor && isExportTextColor
                  ? 25
                  : 14,
            },
          },
        },
        yAxis: {
          name: `${innerText}`,
          nameTextStyle: {
            align: "left",
            color: isShowTextColor ? "#1d244e" : "#bcc2cf",
            fontSize:
              isShowTextColor && !isExportTextColor
                ? 14
                : isShowTextColor && isExportTextColor
                ? 25
                : 14,
          },
          type: "category", // 将xAxis的type设置为value, 将yAxis的type设置为category即可实现横向显示
          data: yAxisData,
          axisLine: { show: !!axisLineShow }, // 轴线
          axisTick: { show: false }, // 刻度
          splitLine: {
            show: false,
            lineStyle: {
              type: "dashed",
              color: "rgba(255,255,255,0.3)",
            },
          },
          axisLabel: {
            // y轴坐标轴样式
            interval: 0,
            textStyle: {
              color: isShowTextColor ? "#1d244e" : "#bcc2cf",
              fontSize:
                isShowTextColor && !isExportTextColor
                  ? 14
                  : isShowTextColor && isExportTextColor
                  ? 25
                  : 14,
            },
          },
        },

        series: [
          {
            type: "bar",
            data: seriesData,
            itemStyle: {
              normal: {
                color: !seriesColor
                  ? this.$echarts.graphic.LinearGradient(1, 0, 0, 1, [
                      {
                        offset: 0,
                        color: colorList[0],
                      },
                      {
                        offset: 1,
                        color: colorList[0],
                      },
                    ])
                  : colorList[0],
                barBorderRadius: [0, 8, 8, 0], // 设置柱状图圆角（顺时针左上，右上，右下，左下）
                label: {
                  show: true, // 开启显示
                  // align: 'left',
                  position: "outside", // 在上方显示
                  distance: 15,
                  textStyle: {
                    // 数值样式
                    color: "#737f9e",
                    // color: !seriesColor ? '#737f9e' : '#737f9e',
                    fontSize:
                      isShowTextColor && !isExportTextColor
                        ? 16
                        : isShowTextColor && isExportTextColor
                        ? 25
                        : 14,
                  },
                },
              },
            },
          },
        ],
      };
      // 渲染图表
      this.pieEcharts.setOption(this.pieOption);
      window.addEventListener("resize", () => {
        this.pieEcharts.resize();
      });
    },
  },
};
</script>

<style scoped></style>
